import React from 'react';
import styled from 'styled-components';

const ItemWrapper = styled.span`
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    width: 48%;
    
    &:nth-child(even){
        margin-left: 4%;
    }

    @media (max-width: 768px){
        width: 100%;
        &:nth-child(even){
            margin-left: 0;
        }
    }
`;

export const ListItems = (props: React.PropsWithChildren<any>) => {
    return (
        <div style={{margin:"10px 0"}}>
            {props.children}
        </div>
    )
}

export const Item = (props: React.PropsWithChildren<any>) => {
    return (
        <ItemWrapper>
            {props.children}
        </ItemWrapper>
    )
}